'use client';

import {
	Disclosure,
	DisclosureButton,
	DisclosurePanel,
} from '@headlessui/react';

import { ChevronBottomIcon, ChevronRightIcon } from '@/shared';

import type { IFaqItem } from '../../types';

export const Faqs = ({ faqs }: { faqs: IFaqItem[] }) => {
	return (
		<div className="columns-1 gap-2 space-y-2 2xl:columns-2 2xl:gap-6 2xl:space-y-6">
			{faqs.map((faq, key) => (
				<Disclosure key={key} defaultOpen={key === 0}>
					{({ open }) => (
						<div className="break-inside-avoid rounded-xl border border-[#DBDFE9] bg-white text-[#252F4A] xl:rounded-3xl 2xl:rounded-[40px]">
							<DisclosureButton className="group flex w-full justify-between gap-4 p-4 xl:p-6 2xl:px-12 2xl:py-8">
								<>
									<span className="flex-1 text-left text-base font-semibold xl:text-2xl 2xl:text-[32px]/[1.3]">
										{faq.title}
									</span>
									{open ? (
										<ChevronBottomIcon className="size-6 xl:size-10 2xl:-mr-4" />
									) : (
										<ChevronRightIcon className="size-6 xl:size-10 2xl:-mr-4" />
									)}
								</>
							</DisclosureButton>
							<DisclosurePanel className="px-4 pb-4 xl:-mt-5 xl:px-6 xl:pb-6 2xl:px-12 2xl:pb-8">
								{faq.text}
							</DisclosurePanel>
						</div>
					)}
				</Disclosure>
			))}
		</div>
	);
};
